import { render, staticRenderFns } from "./RepairParts.vue?vue&type=template&id=505e2979&scoped=true&"
import script from "./RepairParts.vue?vue&type=script&lang=js&"
export * from "./RepairParts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505e2979",
  null
  
)

export default component.exports